export const LEDGER_TYPE_GROUP = {
    CASH_BOOK :0,
    BANK :  1,
    CREDIT_CARD : 2,
    CAPITAL_ACCOUNT :3,
    CASH_CONTROLLER :4
}